export default __webpack_public_path__ + "static/media/aceskey.641d4567.jpg";